import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useSocket } from "../../hooks/useSocket";

const UrgentJobSeekerButton = () => {
  const [isAvailable, setIsAvailable] = useState(null); 
  const [isLoading, setIsLoading] = useState(false); 
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const { socket } = useSocket();

  useEffect(() => {
    // Only fetch status if userId and token are present
    if (!userId || !token) {
      toast.error("Please log in to continue");
      setIsAvailable(false);
      return;
    }

    let isMounted = true; // Prevent state updates after unmount

    const fetchStatus = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}urgent/requests/available/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (isMounted) {
          setIsAvailable(response.data.jobSeeker?.availabilityForUrgentWork || false);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching availability:", error);
          setIsAvailable(false);
          toast.error(error.response?.data?.message || "Failed to load availability");
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchStatus();

    // Cleanup to prevent state updates after unmount
    return () => {
      isMounted = false;
    };
  }, [userId, token]); // Dependencies are stable, so this runs only on mount or when userId/token changes

  const toggleAvailability = async () => {
    if (!userId || !token) {
      toast.error("Please log in to continue");
      return;
    }

    if (isLoading) return; // Prevent multiple clicks

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}urgent/toggle-urgent-availability`,
        { userId, isAvailable: !isAvailable },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const newAvailability = response.data.jobSeeker.availabilityForUrgentWork;
      setIsAvailable(newAvailability);
      toast.success(`Availability ${newAvailability ? "enabled" : "disabled"}`);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update availability");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md max-w-md mx-auto">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Urgent Work Availability</h3>
      {isAvailable === null && !isLoading ? (
        <div className="text-gray-600 text-center">Loading...</div>
      ) : (
        <div className="flex items-center space-x-4">
          <div
            onClick={toggleAvailability}
            className={`relative inline-flex items-center w-16 h-8 rounded-full cursor-pointer transition-colors duration-300 ${
              isAvailable ? "bg-green-500" : "bg-gray-300"
            } ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            <span
              className={`absolute w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                isAvailable ? "translate-x-9" : "translate-x-1"
              }`}
            />
            <span
              className={`absolute text-xs font-medium text-white ${
                isAvailable ? "left-2" : "right-2"
              } transition-all duration-300`}
            >
              {isAvailable ? "ON" : "OFF"}
            </span>
          </div>
          <span className="text-sm text-gray-600">
            {isAvailable ? "Available for urgent work" : "Not available for urgent work"}
          </span>
          {isLoading && <div className="ml-2 text-gray-600">Updating...</div>}
        </div>
      )}
    </div>
  );
};

export default UrgentJobSeekerButton;





















// import { useState, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useSocket } from "../../hooks/useSocket";

// const UrgentJobSeekerButton = () => {
//   const [isAvailable, setIsAvailable] = useState(null);
//   const userId = localStorage.getItem("userId");
//   const token = localStorage.getItem("token");
//   const { socket } = useSocket();

//   useEffect(() => {
//     const fetchStatus = async () => {
//       if (!userId || !token) {
//         toast.error("Please log in to continue");
//         return;
//       }
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}urgent/requests/available/${userId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         setIsAvailable(response.data.jobSeeker?.availabilityForUrgentWork || false);
//       } catch (error) {
//         console.error("Error fetching availability:", error);
//         setIsAvailable(false);
//         toast.error(error.response?.data?.message || "Failed to load availability");
//       }
//     };
//     fetchStatus();
//   }, [userId, token]);

//   const toggleAvailability = async () => {
//     if (!userId || !token) {
//       toast.error("Please log in to continue");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}urgent/toggle-urgent-availability`,
//         { userId, isAvailable: !isAvailable },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setIsAvailable(response.data.jobSeeker.availabilityForUrgentWork);
//       toast.success(`Availability ${response.data.jobSeeker.availabilityForUrgentWork ? "enabled" : "disabled"}`);
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to update availability");
//     }
//   };

//   if (isAvailable === null) {
//     return (
//       <div className="flex justify-center items-center p-6">
//         <div className="text-gray-600">Loading...</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-white rounded-lg shadow-md">
//       <h3 className="text-lg font-semibold text-gray-800 mb-4">Urgent Work Availability</h3>
//       <div className="flex items-center space-x-4">
//         <div
//           onClick={toggleAvailability}
//           className={`relative inline-flex items-center w-16 h-8 rounded-full cursor-pointer transition-colors duration-300 ${
//             isAvailable ? "bg-green-500" : "bg-gray-300"
//           }`}
//         >
//           <span
//             className={`absolute w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
//               isAvailable ? "translate-x-9" : "translate-x-1"
//             }`}
//           />
//           <span
//             className={`absolute text-xs font-medium text-white ${
//               isAvailable ? "left-2" : "right-2"
//             } transition-all duration-300`}
//           >
//             {isAvailable ? "ON" : "OFF"}
//           </span>
//         </div>
//         <span className="text-sm text-gray-600">
//           {isAvailable ? "Available for urgent work" : "Not available for urgent work"}
//         </span>
//       </div>
//     </div>
//   );
// };

// export default UrgentJobSeekerButton;